import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import Loading from "./Loading";
import { Helmet } from "react-helmet";
const SinglePost = ({ match }) => {
  const [post, setPost] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const id = match.params.id;

    //fetch the post with the above id
    let docRef = db.collection("posts").doc(id);

    docRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          setPost(doc.data());
          setLoading(false);
        } else {
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  }, [match.params.id]);
  return (
    <div className="singlepost">
      <Helmet>
        <title>{post.title}</title>
        <meta name="description" content={post.description} />
      </Helmet>
      {loading && <Loading />}

      <h1 className="title">{post.title}</h1>
      <div className="tags">
        {post.tags &&
          post.tags.map((tag, i) => (
            <span className="tag" key={i}>
              #{tag}
            </span>
          ))}
      </div>
      <div>
        <div dangerouslySetInnerHTML={{ __html: post.post }} />
      </div>
    </div>
  );
};

export default SinglePost;
